// extracted by mini-css-extract-plugin
module.exports = {"orders__container":"OrdersTemplate_orders__container__ZaeSE","orders__title":"OrdersTemplate_orders__title__ulRY4","orders__content":"OrdersTemplate_orders__content___yMTB"};